import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import { Card } from 'react-toolbox/lib/card'
import { Flex, Box } from 'reflexbox'

import TimelineDate from './TimelineDate'
import TimelineAction from './TimelineAction'
import Body from 'components/typography/body1/index'

import styles from './styles.scss'

const TimelineDetails = (props) => {
  let name = null
  let action = null
  if (props.name) name = (
    <Flex styleName='usernameContainer' justify='flex-end'>
      <span styleName='username'>by { props.name }</span>
    </Flex>
  )
  if (props.action) action = (<TimelineAction action={props.action}/>)

  return (
    <div styleName='details'>
      <Card theme={styles}>
        <TimelineDate date={props.date}/>
        <Body theme={styles}>{props.comment}</Body>
        { action }
      </Card>
      { name }
    </div>
  )
}

TimelineDetails.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  name: PropTypes.string,
  action: PropTypes.string
}

export default CSSModules(TimelineDetails, styles)
